import { ActionIcon } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconMenu2 } from '@tabler/icons-react';
import cs from 'classnames';
import { useRouter } from 'next/router';
import React, { type FC } from 'react';
import useIsLandscape from '@/DesignSystem/Hook/useIsLandscape';
import { BurgerMenuMobile, LogoMobile, MiniAccount } from '@/Module/DefaultLayout/Component';
import { useCampaign } from '@/Module/DefaultLayout/Hook';
import HeaderMobileBanner from './HeaderMobileBanner';
const DefaultLayoutHeaderMobile: FC = () => {
  const router = useRouter();
  const {
    bannerEnabled
  } = useCampaign();
  const isLandscape = useIsLandscape();
  const notShow = router.pathname.includes('/app/media/') && isLandscape;
  const [opened, {
    close,
    open
  }] = useDisclosure();
  return <>
      {bannerEnabled && !notShow ? <HeaderMobileBanner /> : null}
      <header className={cs("border-[3px] sticky top-0 z-[99] border-blueFive before:z-50 bg-blueFour py-1 text-white before:absolute before:content-[''] before:bg-orangeFour before:w-[calc(100%-0.5rem)]  before:top-1 before-bg-orangeFour  before:left-1 before:right-1  before:transition-all before:duration-300 ")}>
        <div className="container relative  flex  flex-row items-stretch justify-between gap-2">
          <LogoMobile data-sentry-element="LogoMobile" data-sentry-source-file="DefaultLayoutHeaderMobile.tsx" />
          <div className="flex flex-row items-center gap-1">
            <MiniAccount data-sentry-element="MiniAccount" data-sentry-source-file="DefaultLayoutHeaderMobile.tsx" />
            <ActionIcon onClick={open} className="relative z-50 rounded-full bg-transparent" size="xl" aria-label="MenuBar" data-sentry-element="ActionIcon" data-sentry-source-file="DefaultLayoutHeaderMobile.tsx">
              <IconMenu2 stroke={2} size={40} data-sentry-element="IconMenu2" data-sentry-source-file="DefaultLayoutHeaderMobile.tsx" />
            </ActionIcon>
          </div>
        </div>
      </header>
      <BurgerMenuMobile opened={opened} close={close} data-sentry-element="BurgerMenuMobile" data-sentry-source-file="DefaultLayoutHeaderMobile.tsx" />
    </>;
};
export default React.memo(DefaultLayoutHeaderMobile);